module.exports = __webpack_public_path__ + "static/media/icomoon.da80b293.eot";


//////////////////
// WEBPACK FOOTER
// ./src/_assets/fonts/icomoon.eot
// module id = 428
// module chunks = 1